import Vue from 'vue'
import VueStorage from 'vue-ls'
import config from '@/config/default.config'
import { VueAxios } from '@/utils/request'

// base library
import Antd from 'ant-design-vue/es'
import 'ant-design-vue/dist/antd.less'

// ext library
import './directive'
import IconFont from '@/components/IconFont'

Vue.use(Antd)
Vue.use(IconFont)
Vue.use(VueStorage, config.storageOptions)
// mount axios Vue.$http and this.$http
Vue.use(VueAxios)

Vue.prototype.$EventBus = new Vue()
Vue.prototype.$WMSEnvFlag = location.host.includes('wms-open.eccang.com')

process.env.NODE_ENV !== 'production' && console.warn('[antd-pro] WARNING: Antd now use fulled imported.')
